module.exports = __webpack_public_path__ + "img/1518974168.9318cb7d.jpg";